// Google Analytics & Conversion Tracking Utility
// Google Ads: AW-18079218842
// GA4: Add your Measurement ID in index.html

const GOOGLE_ADS_ID = 'AW-18079218842';

// Check if gtag is loaded and consent given
function isGtagReady() {
  return typeof window.gtag === 'function';
}

// Send custom event to GA4 + Google Ads
export function trackEvent(eventName, params = {}) {
  if (!isGtagReady()) return;
  window.gtag('event', eventName, params);
}

// ---- CONVERSION EVENTS ----

export function trackPhoneClick() {
  trackEvent('conversion', {
    send_to: `${GOOGLE_ADS_ID}/phone_click`,
    event_category: 'contact',
    event_label: 'phone_call',
    value: 1.0,
  });
  trackEvent('phone_click', { event_category: 'contact', event_label: '+491631945793' });
}

export function trackWhatsAppClick() {
  trackEvent('conversion', {
    send_to: `${GOOGLE_ADS_ID}/whatsapp_click`,
    event_category: 'contact',
    event_label: 'whatsapp',
    value: 1.0,
  });
  trackEvent('whatsapp_click', { event_category: 'contact', event_label: 'whatsapp_message' });
}

export function trackEmailClick() {
  trackEvent('conversion', {
    send_to: `${GOOGLE_ADS_ID}/email_click`,
    event_category: 'contact',
    event_label: 'email',
    value: 1.0,
  });
  trackEvent('email_click', { event_category: 'contact', event_label: 'info@panthera-umzug.de' });
}

// ---- CTA & UI EVENTS ----

export function trackCTAClick(buttonName, pageName) {
  trackEvent('cta_click', {
    event_category: 'engagement',
    event_label: buttonName,
    page_name: pageName,
  });
}

export function trackPageView(pagePath, pageTitle) {
  if (!isGtagReady()) return;
  window.gtag('event', 'page_view', {
    page_path: pagePath,
    page_title: pageTitle,
  });
}

// ---- SCROLL DEPTH TRACKING ----

let scrollMilestones = new Set();

export function initScrollTracking() {
  const milestones = [25, 50, 75, 100];
  
  const handleScroll = () => {
    const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollHeight <= 0) return;
    const scrollPercent = Math.round((window.scrollY / scrollHeight) * 100);

    milestones.forEach((m) => {
      if (scrollPercent >= m && !scrollMilestones.has(m)) {
        scrollMilestones.add(m);
        trackEvent('scroll_depth', {
          event_category: 'engagement',
          event_label: `${m}%`,
          value: m,
        });
      }
    });
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  return () => window.removeEventListener('scroll', handleScroll);
}

// Reset scroll tracking on page change
export function resetScrollTracking() {
  scrollMilestones = new Set();
}

// ---- COOKIE CONSENT ----

export function grantConsent() {
  localStorage.setItem('cookie_consent', 'granted');
  if (!isGtagReady()) return;
  window.gtag('consent', 'update', {
    'ad_storage': 'granted',
    'ad_user_data': 'granted',
    'ad_personalization': 'granted',
    'analytics_storage': 'granted',
  });
}

export function denyConsent() {
  localStorage.setItem('cookie_consent', 'denied');
  if (!isGtagReady()) return;
  window.gtag('consent', 'update', {
    'ad_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'analytics_storage': 'denied',
  });
}

export function getConsentStatus() {
  return localStorage.getItem('cookie_consent');
}

// Initialize consent from localStorage on load
export function initConsent() {
  const status = getConsentStatus();
  if (status === 'granted') {
    grantConsent();
  }
}
